import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import ArticleList from "../article/articleList";
import MultiScanForm from "../MultiScanForm/MultiScanForm";
import Numpad from "../numpad/Numpad";
import { MobileInlineScanner } from "../Scanner/MobileInlineScanner";
import { useSelectedArticleStore } from "../../store/store";
import { Article, PurchaseOrder } from "../../api/order/generated/src";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";



export interface IBatchItem {
    batch: string;
    booked: number;
}

export interface ISerialnumberItem {
    serial: string
    booked: number;
}

// export interface IArticle {
//     id: string;
//     title: string;
//     booked: number;
//     ordered: number;

//     batchItems?: IBatchItem[]
//     serialItems?: ISerialnumberItem[]
// }

interface IOrderDetailProps {

}

const OrderDetail = (props:IOrderDetailProps) => {
    const { orderId } = useParams();

    const { t } = useTranslation();

    const [articles, setArticles] = useState<Article[]>();

    const [lastChanged, setLastChanged] = useState<Article>();


    
    const selectedArticle = useSelectedArticleStore(state => state.article);
    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);

    useEffect(() => {

        const purchaseOrder:PurchaseOrder = {
            id: "1",
            annotation: "NS0156.525 - KW30 NC0190.004 - KW32 ND...",
            externalId: "11169",
            tsCreated: new Date(Date.parse("11.07.2025 11:05")),
            vendor: {
                id: "1",
                name: "Komet Medical"
            },
            articles: [
                {
                    id: "1",
                    externalId: "NS0156.525",
                    title: "rund/round - 6,0mm - 14 Schneiden/flutes - Hilan XS - II",
                    quantityBooked: 0,
                    quantity: 5
                },
                {
                    id: "2",
                    externalId: "ND0134.009",
                    title: "rund-3,5mm-medium",
                    quantityBooked: 1,
                    quantity: 1,
                    batchItems: [
                        {
                            batch: "090166",
                            quantityBooked: 1,
                            bestBefore: new Date(Date.parse("11.07.2026 11:05")),
                            productionDate: new Date(Date.parse("11.06.2025 11:05")),
                        }
                    ]
                },
                {
                    id: "3",
                    externalId: "ND0146.009",
                    title: "rund-1,8mm-medium",
                    quantityBooked: 0,
                    quantity: 1
                },
                {
                    id: "4",
                    externalId: "ND0190.009",
                    title: "rund/round - 2,7mm - medium",
                    quantityBooked: 2,
                    quantity: 2,
                    serialItems: [
                        {
                            serial: "0815",
                            quantityBooked: 1
                        },
                        {
                            serial: "0816",
                            quantityBooked: 1
                        }
                    ]
                }
            ]
        }

        const articleList = purchaseOrder.articles;

        // const articleList:IArticle[] = [{
        //     id: "1",
        //     title: "Test Artikel 1",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "2",
        //     title: "Test Artikel 2",
        //     booked: 5,
        //     ordered: 5,
        //     batchItems: [
        //         {
        //             batch: "0815",
        //             booked: 2
        //         },
        //         {
        //             batch: "0816",
        //             booked: 3
        //         }
        //     ]
        // },{
        //     id: "3",
        //     title: "Test Artikel 3",
        //     booked: 0,
        //     ordered: 5,
        //     serialItems: [
        //         {
        //             serial: "0815",
        //             booked: 1
        //         },
        //         {
        //             serial: "0816",
        //             booked: 1
        //         }
        //     ]

        // },{
        //     id: "4",
        //     title: "Test Artikel 4",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "5",
        //     title: "Test Artikel 5",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "6",
        //     title: "Test Artikel 6",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "7",
        //     title: "Test Artikel 7",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "8",
        //     title: "Test Artikel 8",
        //     booked: 0,
        //     ordered: 10
        // },{
        //     id: "9",
        //     title: "Test Artikel 9",
        //     booked: 0,
        //     ordered: 10
        // }]


        setArticles(articleList);
    }, [orderId]);

    const checkScan = useCallback(async (scanned:string) => {
        // hier ID aus Scan ermitteln

        return null;
    }, []);
    
    const runSearch = useCallback(async (id:string) => {

        console.log(articles);
        
        
        try {
            // hier die Suche anhand der ID ausführen und weiterleiten


            // dummy ... erstmal den ersten verwenden, bis Api steht
            const changed = articles?.find((itm) => {
                return itm.id === id;
            });

            if(changed != null && changed.id != null){
                
                setSelectedArticle(changed.id, changed.batchItems?.[0]?.batch ?? "");

                setLastChanged(changed);
    
                // setShowNumpad(true);
            }


            
        } catch (error) {
            console.log(error);
            
        }

        return false;
    }, [articles]);


    const [showNumpad, setShowNumpad] = useState<boolean>(false);

    useEffect(() => {
        if(lastChanged != null){
            setShowNumpad(true);

            const element = document.querySelector('.selected-article');
            element?.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }, [lastChanged]);
 

    return (
        // <div className="w-full h-screen">
        //     <div className="gap-4 grid w-full">
    
        //         <div className="bg-gray">
                    <div className="mx-auto max-w-screen-2xl flex flex-col">

                        <div className="mb-4">
                            <MultiScanForm 
                                checkScan={checkScan}
                                runSearch={runSearch}
                            />

                        </div>


                        {/* <div className="w-full flex justify-center align-center">
                            <MobileInlineScanner />
                        </div> */}

                        
                        <div className="flex-1 min-h-0 overflow-y-auto bg-white rounded-b-lg">
                            { articles != null && 
                                <ArticleList 
                                    articles={articles} 
                                    // defaultSelected={lastChanged?.id}

                                />
                            }
                        </div>

                        <div className="flex justify-end">
                            <Button variant="contained" color="secondary" >
                                {t("common:confirmIncommingGoods")}
                            </Button>
                        </div>

                        
                        {/* <Numpad 
                            open={showNumpad}
                            handleClose={() => {
                                setShowNumpad(false);
                            }}
                        /> */}
                        
                    </div>
        //         </div>
        //     </div>
           
        // </div>
    )
};

export default OrderDetail;
